import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface EventDataState {
  type_value?: number;
  [key: string]: unknown;
}

const initialState: EventDataState = {};

export const eventDataSlice = createSlice({
  name: 'eventData',
  initialState,
  reducers: {
    setEventData: (state, { payload: data }: PayloadAction<EventDataState>) => {
      return data;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setEventData } = eventDataSlice.actions;

export const getEventData = (state: RootState) => state.eventData;

export default eventDataSlice.reducer;
